import Panel from "../Panel.js"

export default class OptionsPanel extends Panel {

  constructor(props, context) {
    super(props, context)
  }

  static get contextTypes() {
    return super.contextTypes
  }


  select() {
    const options = this.listOptions
    const props = this.props.captionsettings
    const len = options.length
    for (let i = 0; i < len; i++) {
      if ((/color/i.test(this.setting) && (options[i].value.r == props[this.setting].r) && (options[i].value.g == props[this.setting].g) && (options[i].value.b == props[this.setting].b)) ||
          (/opacity/i.test(this.setting) && (options[i].value == props[this.setting.replace("Opacity", "Color")].a)) ||
          (!/opacity|color/i.test(this.setting) && options[i].value == props[this.setting])) {
        this.state.activeIndex = i
        break
      }
    }
  }

  clickHandler (object, index) {
    super.clickHandler(object, index)
    this.props.settingsChange({[this.setting]: object})
  }

  backHandler(event) {
    this.props.viewChange(event, "options")
  }
}
